import { Gizmo } from '../../gizmos';
import { IGizmoData } from '../../types';

interface IParams {
  operation: string;
  elements: IGizmoData[];
  context: {
    gizmo?: Gizmo;
  };
}

/**
 * Agreggate gizmo data
 *
 * @param {string} operation operation we're going to apply to the Gizmo data list
 * @param {IGizmoData[]} elements Gizmo data list
 * @returns
 */
function aggregate({ operation, elements }: IParams): Promise<any> {
  return new Promise<any>(async resolve => {
    // const { gizmo } = context;
    if (operation === 'sum' && elements && Array.isArray(elements)) {
      const result = elements.reduce((prev, curr) => {
        let current = 0;

        if (curr && curr.v && typeof curr.v === 'number') {
          current = curr.v;
        }

        return prev + current;
      }, 0);

      return resolve(result);
    } else if (operation === 'count' && elements && Array.isArray(elements)) {
      return resolve(elements.length);
    }

    resolve(undefined);
  });
}

export default aggregate;
